import React from "react";
import Modal from "@components/modal";
import { ProgrammingStructure } from "@models/ISchema";
import { Text } from "@foris/avocado-suite";
import { useTranslation } from "react-i18next";

interface PublishStructureModalProps {
  isOpen?: boolean;
  programmingStructure?: ProgrammingStructure;
  isEditing?: boolean;
  onClose: () => void;
  onPublish: () => void;
}

const PublishStructureModal = ({
  isOpen,
  programmingStructure,
  isEditing,
  onClose,
  onPublish,
}: PublishStructureModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      typeState="confirm"
      show={isOpen}
      title={t("programming-structures.modals.publish-structure.title")}
      textButtonPrincipal={t("programming-structures.modals.publish-structure.publish")}
      textButtonSecondary={t(
        `programming-structures.modals.publish-structure.${!isEditing ? "cancel" : "keep-editing"}`,
      )}
      onClose={onClose}
      onClickPrincipal={onPublish}
      onClickSecondary={onClose}
    >
      <Text>
        {t("programming-structures.modals.publish-structure.description", {
          code: programmingStructure?.code,
          name: programmingStructure?.name,
        })}
      </Text>
    </Modal>
  );
};

export default PublishStructureModal;
